import * as React from 'react';
import { debounce } from '@cian/newbuilding-utils';
import { FILTER_DEBOUNCE_TIME } from '../constants/filter';
import { fetchLayouts } from '../services/layouts';
import { NewbuildingLayoutsContext } from '../shared/context';
import { mapOffersLink } from '../utils/mapOffersLink';
import { getFilterParams, setRoomQueryParams } from '../utils/queryStringHelper';
export const useLayouts = _ref => {
  let {
    newbuildingId,
    isHouseLayoutsAvailable,
    houseId,
    isQueryParamsEnabled
  } = _ref;
  const {
    httpApi,
    logger
  } = React.useContext(NewbuildingLayoutsContext);
  const [roomType, setRoomType] = React.useState([]);
  const [layouts, setLayouts] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const [lastPage, setLastPage] = React.useState(1);
  const [offersLinks, setOffersLinks] = React.useState();
  const loadLayouts = React.useCallback(params => {
    setIsLoading(true);
    fetchLayouts({
      params,
      httpApi,
      logger
    }).then(layoutsInfo => {
      if (!layoutsInfo) {
        setIsLoading(false);
        setLayouts([]);
        setRoomType([]);
        return;
      }
      setLayouts(layoutsInfo.fromDeveloperLayouts);
      setRoomType(layoutsInfo.filters.roomType);
      if (layoutsInfo.pagination) {
        setPage(layoutsInfo.pagination.page);
        setLastPage(layoutsInfo.pagination.lastPage);
      } else {
        setPage(1);
        setLastPage(1);
      }
      setOffersLinks(mapOffersLink(layoutsInfo));
      setIsLoading(false);
    });
  }, []);
  const loadLayoutsDebounced = React.useMemo(() => debounce(FILTER_DEBOUNCE_TIME, loadLayouts), []);
  React.useLayoutEffect(() => {
    if (!isHouseLayoutsAvailable) {
      setLayouts([]);
      return;
    }
    const queryFilterParams = getFilterParams(isQueryParamsEnabled);
    let roomTypeFilter = roomType;
    if (queryFilterParams.roomTypes.length > 0) {
      setRoomType(queryFilterParams.roomTypes);
      roomTypeFilter = queryFilterParams.roomTypes;
    }
    loadLayoutsDebounced({
      newbuildingId,
      houseId,
      roomType: roomTypeFilter,
      page: 1
    });
  }, [newbuildingId, houseId, isHouseLayoutsAvailable, isQueryParamsEnabled]);
  const onPageChange = React.useCallback(page => {
    setPage(page);
    loadLayoutsDebounced({
      houseId,
      newbuildingId,
      roomType,
      page
    });
  }, [roomType, houseId, newbuildingId]);
  const onRoomTypeChange = React.useCallback(roomType => {
    if (isQueryParamsEnabled) {
      setRoomQueryParams(roomType);
    }
    setRoomType(roomType);
    loadLayoutsDebounced({
      houseId,
      newbuildingId,
      roomType,
      page: 1
    });
  }, [page, houseId, newbuildingId, isQueryParamsEnabled]);
  return {
    onRoomTypeChange,
    layouts,
    roomType,
    isLoading,
    offersLinks,
    pagination: {
      page,
      lastPage,
      onPageChange
    }
  };
};